import { Identifier, useNotify, useRedirect, useDataProvider } from 'react-admin';
import { useMutation } from 'react-query';
import Button from '@mui/material/Button';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useRecordContext, useResourceContext } from 'react-admin';

export const ToolbarDuplicateButton = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const dataProvider = useDataProvider();
  const record = useRecordContext();
  const resource = useResourceContext();

  const { mutate, isLoading } = useMutation(() => dataProvider.duplicate({ resource, id: record?.id }), {
    onSuccess: (result?: { id?: Identifier }) => {
      const newId = result?.id;

      if (!newId) {
        notify('Duplication error: missing new record id', { type: 'warning' });
        return;
      }

      redirect('edit', resource, newId);
      notify('Duplicate successfully created');
    },
    onError: (error: Error) => {
      notify(`Duplication error: ${error.message}`, { type: 'warning' });
    },
  });

  if (!record || record.id == null) {
    return null;
  }

  return (
    <Button
      color="secondary"
      variant="outlined"
      startIcon={<FileCopyIcon />}
      onClick={() => mutate()}
      disabled={isLoading}
    >
      Duplicate
    </Button>
  );
};
